module.exports = __webpack_public_path__ + "static/media/emclogo.30507f24.png";